import { proxyCustomElement, HTMLElement, h, Host, Fragment } from '@stencil/core/internal/client';

const dividerCss = ":host{align-items:center;display:flex;justify-content:center}.line{background-color:var(--jw-theme-surface-divider-color);flex:1;height:1px;width:100%}.or-text{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;padding:.25rem .75rem;text-transform:uppercase}:host([type=vertical]){min-height:100%;width:1px}:host([type=vertical]) .line{height:100%;max-height:100%;min-height:1.5rem;width:100%}";
const WuiDividerStyle0 = dividerCss;

const WuiDivider = /*@__PURE__*/ proxyCustomElement(class WuiDivider extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = 'horizontal';
    }
    render() {
        return (h(Host, { key: '9b293a55a5413764bcd280e0fb709bfa1592795c' }, h("div", { key: '7de3008f33fb1066f70b7c24ca40296a271d8d1f', class: "line" }), this.type === 'horizontal-or' && (h(Fragment, { key: 'e38722dee8a0d003af89dd5482b10ea312e5960d' }, h("div", { key: '643e2e2f77211d970ac678cb16afbd7d4c65ea4c', class: "or-text" }, "OR"), h("div", { key: 'b142754fcb7bc8f3c344753403f4e61b207ff0b9', class: "line" })))));
    }
    static get style() { return WuiDividerStyle0; }
}, [1, "wui-divider", {
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDivider);
            }
            break;
    } });
}
defineCustomElement();

export { WuiDivider as W, defineCustomElement as d };

//# sourceMappingURL=divider.js.map